/** Shared scene clocks for menu chrome. */

/** Any click-in is finished long before this; a shot frame opens on settled chrome. */
export const SHOT_AGE = 1000;

/**
 * Opening age for a scene clock: 0 in play, already settled under a `?shot=` hook so a
 * capture never catches a panel mid-flight.
 */
export function enterAge(shot: string | null): number {
  return shot ? SHOT_AGE : 0;
}

/** Ease-out quart 0..1. Snaps when reduced. */
export function settleT(age: number, reduced: boolean, ms = 100): number {
  if (reduced || age >= ms) return 1;
  const t = Math.max(0, Math.min(1, age / ms));
  return 1 - (1 - t) ** 4;
}
